import register       from '../../register.js';
import $              from 'jquery';
import FormSequence   from '../classes/form-sequence';
import extend         from '../util/extend';
import create_account from '../steps/create-account/step';
import select_plan    from '../steps/select-plan/step';
import contact        from '../steps/contact/step';
import schedule       from '../steps/schedule-install-fsl/step';
import complete       from '../steps/signup-confirmation/step';
import success        from '../steps/success/step';
import payment        from '../steps/payment/step';
import stepNumbers    from '../templates/components/step-numbers.hbs';
import signupTemplate from '../templates/signup-sequence.hbs';
import error          from '../steps/error/step';
import dispatchError  from '../steps/dispatch-error/step';
import footerTemplate from '../templates/components/footer.hbs';
import cookie         from '../util/cookie';

export default register( 'signup', () => {

  let submitPending = false;

  // If the medium or source is ssr, change the order of signup
  // to move schedule earlier
  const src_ssr = cookie.getItem('utm_source') === 'ssr';
  const med_ssr = cookie.getItem('utm_medium') === 'ssr';
  const ssr     = src_ssr || med_ssr;

  const sequence = new FormSequence({
    $el: $('.signup-container'),
    first: 'select_plan',
    template: signupTemplate,
    events: {
      showStep: 'trackStep'
    },
    state: {
      referral_code_used: window.referral_code || null,
      referral_code_days: Boolean( window.referral_code ) ? 30 : 0,
      aps_ineligible_zip: !!window.aps_ineligible_zip
    },
    configs: {
      select_plan: {
        step: select_plan,
        next: ssr ? 'schedule_install' : 'contact',
        footer: footerTemplate(),
        hideControls: true,
        nextText: 'Sign up'
      },
      contact: {
        step: contact,
        next: 'create_account',
        footer: footerTemplate({ pii_signup: true }),
        description: stepNumbers({ active: ssr ? 2 : 1, num_steps: 4 })
      },
      create_account: {
        step: create_account,
        next: ssr ? 'payment' : 'schedule_install',
        description: stepNumbers({ active: ssr ? 3 : 2, num_steps: 4 }),
        footer: footerTemplate()
      },
      schedule_install: {
        step: schedule,
        next: ssr ? 'contact' : 'payment',
        description: stepNumbers({ active: ssr ? 1 : 3, num_steps: 4 }),
        footer: footerTemplate()
      },
      payment: {
        step: payment,
        next: null,
        description: stepNumbers({ active: 4, num_steps: 4 }),
        footer: footerTemplate({ subscription_text: true })
      },
      success: {
        step: complete,
        next: null
      },
      unknown_address_success: {
        step: success,
        next: null
      },
      error: {
        step: error,
        next: null
      },
      dispatch_error: {
        step: dispatchError,
        next: null
      }
    },

    onSubmit( e ) {
      // block submit if ajax call is currently in flight
      if ( submitPending ) {
        e.preventDefault();
        return false;
      }

      const conf = this.configs[ this.currStep ];
      const state = this.store.getState();
      const btn = this.$el.find( this.submitSelector );

      // only set submitPending flag if we plan to send this to the server
      if ( !$( e.target ).hasClass( this.disabledClass ) ) {
        submitPending = true;
        btn.addClass('loading');
        const before = conf.step.beforeNext || function( state, f ) { f(); };
        before.call( conf.step, state, err => {
          if ( err ) {
            submitPending = false;
            btn.removeClass('loading');
            return;
          }
          this.submit();
        });
      } else {
        conf.step.isValid( state, true );
      }
    },

    submit() {

      const url = '/signup';
      const successStep = 'success';

      const state = extend( {}, this.store.getState() );

      const install_date = new Date( state.install_date );
      const now          = new Date();
      const btn          = this.$el.find( this.submitSelector );
      const sameday      = location.search.indexOf('sameday=true') !== -1;
      const buffer       = sameday ? 0 : 1000 * 60 * 60 * 3.5;

      // if user is within 3.5 hours of the install time, and the URL doesn't
      // contain sameday=true to indicate a field marketing event, make 'em
      // go back and choose a new time
      if ( install_date - now < buffer ) {
        const msg = [
          'Your chosen appointment time is no longer available.',
          'Please choose another.'
        ].join(' ');

        submitPending = false;
        btn.removeClass('loading');
        sequence.showStep('schedule_install');
        schedule.resetPicker();
        schedule.showDateError( msg );
        return;
      }

      delete state.promo_code;
      delete state.plan_amount;
      delete state.trial_period_days;

      btn.addClass('loading');

      let stateJson;

      try {
        stateJson = JSON.stringify( state );
      } catch ( e ) {
        console.log( e );
      }

      $.ajax({
        method: 'POST',
        url,
        contentType: 'application/json',
        data: stateJson,
        success: user => {
          sequence.store.dispatch({
            type: 'change',
            data: { user_id: user._id }
          });

          sequence.onSuccess( successStep );

          if ( window.acumen ) {
            const address = user.shipping_address || {};

            let addressname = null;

            const { line_1, city, state, postal_code } = address;
            if ( line_1 && city && state && postal_code ) {
              const addressNameValues = [ line_1, city, state, postal_code ];
              addressname = addressNameValues.join(', ');
            }

            window.acumen.track( 'web-submit-payment', { success: true } );

            window.acumen.track( 'web-submit-signup', {
              place_id: user.place_id || null,
              first_name: (
                user.shipping_address &&
                user.shipping_address.first_name
              ) || null,
              last_name: (
                user.shipping_address &&
                user.shipping_address.last_name
              ) || null,
              address: addressname,
              unit: address.line_2 || null,
              phone: user.phone || null,
              email: user.email || null
            });

            window.acumen.identify({
              user_id: user._id,
              email: user.email
            });
          }
        },
        complete: () => {
          btn.removeClass('loading');
          submitPending = false;
        },
        error: xhr => {
          let responseJSON;

          const showDefaultError = ( error = {} ) => {
            const msg = 'Something went wrong. Please try again';
            const $submit = sequence.$el.find('.sequence-submit');

            sequence.showStep( 'error', false, {
              errors: {
                message: error.message || msg
              },
              showHelp: true
            });

            $submit.addClass('hidden');
          };

          try {
            responseJSON = JSON.parse( xhr.responseText );
          } catch ( e ) {
            showDefaultError();
          }

          if ( responseJSON.dispatch_error ) {
            sequence.showStep('dispatch_error');
          } else if ( xhr.status === 400 && responseJSON.stripe_message ) {
            if ( window.acumen ) {
              window.acumen.track( 'web-submit-payment', {
                success: false,
                error: responseJSON.stripe_message
              });
            }
            sequence.onPaymentError( responseJSON.stripe_message );
          } else if (
            responseJSON.slug        === 'slot_expired' ||
            responseJSON.fsl_message === 'slot_expired'
          ) {
            const msg = [
              'Your chosen appointment time is no longer available.',
              'Please choose another.'
            ].join(' ');

            sequence.showStep('schedule_install');
            schedule.resetPicker();
            schedule.showDateError( msg );
          } else if ( xhr.status === 409 ) {

            sequence.configs.create_account.description = stepNumbers({
              active: 4,
              num_steps: 4
            });
            sequence.configs.create_account.next = null;

            sequence.showStep( 'create_account', false, {
              errors: { email: 'This email is already in use' }
            });

            sequence.$el.find('.sequence-next').addClass('disabled');

          } else {
            showDefaultError( responseJSON );
          }
        }
      });
    },

    onPaymentError( errorMessage ) {
      if ( sequence.currStep !== 'payment' ) {
        sequence.showStep('payment');
      }
      const paymentStep = sequence.configs['payment'].step;
      paymentStep.showCardError( errorMessage );
    },

    // this is gross, but honestly, it seemed wrong to try to bake this in
    // to FormSequence generically, because I don't think it's likely that
    // success pages will always behave this way
    onSuccess( successStep ) {
      sequence.showStep( successStep );
      sequence.$el.find('.sequence-prev, sequence-submit').hide();

      const $submit = sequence.$el.find('.sequence-submit');

      $submit.off();
      $submit.text('Done');

      $submit.on( 'click', ( ev ) => {
        ev.stopPropagation();
        window.location = 'https://starry.com/internet';
      });
    },

    trackStep( name, conf ) {
      window.dataLayer = window.dataLayer || [];

      const state   = this.store.getState() || {};
      const address = state.address || window.preloaded_address || {};

      window.dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': `/signup/${ name }`,
        'virtualPageTitle': conf.title || name,
        'place_id': address.place_id
      });

      if ( window.acumen && window.acumen.track ) {
        const meta = {
          view: name,
          title: conf.title || name,
          place_id: address.place_id
        };

        if ( typeof conf.trackingData === 'function' ) {
          Object.assign( meta, conf.trackingData() );
        }

        window.acumen.track( 'virtual-pageview',  meta );
      }
    }
  });

  window.sequence = sequence;

});
